import { HYPERBEAT_TOKEN_ADDRESS } from '@hyperswap/addresses'
import { Currency } from '@uniswap/sdk-core'
import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import CurrencyLogo from 'components/CurrencyLogo'
import IntroCard from 'components/IntroCard'
import { SkeletonText } from 'components/Skeleton'
import { API_POOL_BASE_URL, LINKS } from 'constants/links'
import { useActiveWeb3React } from 'hooks'
import { useToken } from 'hooks/Tokens'
import React, { useContext, useState } from 'react'
import { usePrivy } from '@privy-io/react-auth'
import styled, { ThemeContext } from 'styled-components'
import { TYPE } from 'theme'
import Stake from './Stake'
import Unstake from './Unstake'
import { useTokenBalance } from 'state/wallet/hooks'
import { roundToDecimalPlace } from 'utils/data'

import WithdrawalStatus from './WithdrawalStatus'
import axios from 'axios'
import HBHYPEGraph from './HBHYPEGraph'
export const Tabs = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  border-radius: 14px;
  display: flex;
  gap: 2px;
`

export const StyledTabButton = styled.button<{ isActive?: boolean }>`
  ${({ theme }) => theme.flexRowNoWrap}
  border: none;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: white;
  padding: 8px 16px;
  border-radius: 14px;
  font-weight: 600;
  font-size: 14px;
  transition: all 300ms;
  background: ${({ isActive }) => (isActive ? '#4AFC38' : 'transparent')};
  color: ${({ isActive }) => (isActive ? 'black' : 'white')};

  &:hover {
    color: #4afc38;
  }

  ${({ isActive }) =>
    isActive &&
    `
    &:hover {
      color: black !important;
    }
  `}
`

const ConnectWalletContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  min-height: 25vh;
  background: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 14px;
  width: 100%;

  div {
    max-width: 300px;
  }
`

const Links = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 6px;
  gap: 2px;
  a {
    padding: 2px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 300ms ease;

    &:hover {
      background: #e2e8f0;
      svg {
        color: black;
      }
    }
  }
  svg {
    width: 16px;
    height: 16px;
    color: white;
  }
`

const GridContainer = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: calc(55% - 8px) calc(45% - 8px);
  }
`

const EntriesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0px, 1fr));
  gap: 15px 0.5rem;
  padding: 0;
  margin-top: 6px;
`

const SubContainer = styled.div<{ bg1: boolean }>`
  background: ${({ theme }) => theme.bg0};
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
const SubContainerHeader = styled.div`
  border-radius: 14px;
  background: ${({ theme }) => theme.bg1};
  padding: 20px;
  p {
    color: ${({ theme }) => theme.text2};
    font-size: 12px;
    margin-bottom: 0;
  }
`

const SubContainerBody = styled.div`
  padding: 20px;
  background: ${({ theme }) => theme.bg0};
`

const EarnHBHYPE = () => {
  const { account, chainId, library } = useActiveWeb3React()
  const { login } = usePrivy()
  const theme = useContext(ThemeContext)
  const [tab, setTab] = React.useState<0 | 1>(0)
  const hbHYPE = useToken(HYPERBEAT_TOKEN_ADDRESS)
  const [currencyIdA, setCurrencyIdA] = useState<string | undefined>('HYPE')
  const [totalSupply7D, setTotalSupply7D] = useState<any[]>([])
  const [hypePrice, setHypePrice] = useState<number>(0)

  const [data, setData] = useState<any>({
    apr: null,
    totaHBHYPEStaked: null,
    rateHBHYPEToHYPE: null,
  })
  const [loading, setLoading] = useState<boolean>(true)
  const lToken = useToken(HYPERBEAT_TOKEN_ADDRESS)
  const tokenBalance = useTokenBalance(account ?? undefined, lToken ?? undefined)

  React.useEffect(() => {
    async function fetchData() {
      try {
        if (library && account) {
          const hypePriceResponse = await axios.get(
            'https://api.coingecko.com/api/v3/coins/hyperliquid/market_chart?vs_currency=usd&days=0'
          )
          setHypePrice(hypePriceResponse?.data?.prices?.[0]?.[1])
          const dataAPI = await axios.get(`${API_POOL_BASE_URL}/api/hbHype/totalSupply`)
          const totalSupply = dataAPI.data?.data?.timeseriesCalls?.[0]?.data
          setTotalSupply7D(totalSupply)

          setData({
            apr: '6',
            tvl: null,
            rate: null,
          })

          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }

    if (!chainId || !library || !account) return
    if (loading) {
      fetchData()
    }
  }, [account, chainId, library, loading])

  const setRefresh = () => {
    setLoading(true)
  }

  const randomKey = Math.random() * 99999

  const lastTVL = [...totalSupply7D].sort((a, b) => b.timestamp - a.timestamp)[0]?.value

  return (
    <>
      <IntroCard variant={5} Key="HBHYPE">
        <h1>Deposit now, earn liquid yield and points automatically</h1>
        <p>
          The best risk-adjusted return on your HYPE, dynamically allocating captial through strategies typically
          exclusive to institutions now democratised for all. <br />
          <br />
          Powered by Hyperbeat
        </p>
        <Links>
          <a href="https://app.hyperbeat.org/" target="_blank" rel="noreferrer" aria-label="Hyperbeat Website">
            {LINKS['landingPage'].logo}
          </a>
          <a href="https://x.com/0xhyperbeat" target="_blank" rel="noreferrer" aria-label="Hyperbeat Twitter">
            {LINKS['twitter'].logo}
          </a>
        </Links>
      </IntroCard>
      <AutoColumn gap="lg" justify="center">
        <AutoColumn gap="lg" style={{ width: '100%' }}>
          {!account ? (
            <ConnectWalletContainer>
              <div>
                <TYPE.mediumHeader textAlign="center" color={theme.text3}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-tax"
                    style={{ marginBottom: '.5rem' }}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M8.487 21h7.026a4 4 0 0 0 3.808 -5.224l-1.706 -5.306a5 5 0 0 0 -4.76 -3.47h-1.71a5 5 0 0 0 -4.76 3.47l-1.706 5.306a4 4 0 0 0 3.808 5.224" />
                    <path d="M15 3q -1 4 -3 4t -3 -4z" />
                    <path d="M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                    <path d="M12 10v1" />
                    <path d="M12 17v1" />
                  </svg>

                  <div>{'Connect your wallet to stake tokens and earn hbHYPE.'}</div>
                </TYPE.mediumHeader>
                <ButtonPrimary
                  style={{ marginTop: '2em', padding: '8px 16px' }}
                  onClick={() =>
                    login({
                      loginMethods: ['wallet'],
                      walletChainType: 'ethereum-only',
                      disableSignup: false,
                    })
                  }
                >
                  Connect a wallet
                </ButtonPrimary>
              </div>
            </ConnectWalletContainer>
          ) : (
            <GridContainer>
              <div>
                <SubContainer bg1={false}>
                  <>
                    <SubContainerHeader>
                      <div style={{ display: 'flex', fontSize: '16px', marginBottom: '12px' }}>
                        <CurrencyLogo currency={hbHYPE as Currency} size={'42px'} />
                        <h2 style={{ fontSize: '16px', marginLeft: '12px' }}>Earn hbHYPE</h2>
                      </div>

                      <EntriesContainer>
                        <span style={{ fontSize: '14px', fontWeight: 800 }}>APY</span>
                        <span style={{ fontSize: '14px', fontWeight: 800 }}>TVL</span>
                      </EntriesContainer>
                      <EntriesContainer>
                        <span style={{ fontSize: '14px', fontWeight: 400, height: '16px' }}>
                          {loading || !data?.apr ? (
                            <SkeletonText width="40%" height="100%" />
                          ) : (
                            `${roundToDecimalPlace(data?.apr, '2')}%`
                          )}
                        </span>
                        <span style={{ fontSize: '14px', fontWeight: 400, height: '16px' }}>
                          {loading || !lastTVL ? (
                            <SkeletonText width="30%" height="100%" />
                          ) : (
                            `${roundToDecimalPlace(lastTVL, '3')} hbHYPE`
                          )}
                        </span>
                      </EntriesContainer>

                      <HBHYPEGraph totalSupply7D={totalSupply7D} hypePrice={hypePrice} />

                      <p style={{ marginBottom: '0' }}>
                        <u>Disclaimer</u>: The deposit services provided on this page are powered by Hyperbeat and are
                        not directly developed or maintained by HyperSwap Exchange. While we collaborate with reputable
                        partners, please note that HyperSwap Exchange does not control or manage the underlying smart
                        contracts associated with these deposit operations.
                      </p>
                    </SubContainerHeader>

                    <SubContainerBody>
                      <div style={{ marginTop: '16px' }}>
                        <EntriesContainer>
                          <span style={{ fontWeight: 800, fontSize: '16px' }}>Deposited</span>
                        </EntriesContainer>
                        <EntriesContainer>
                          {loading ? (
                            <span style={{ fontSize: '20px', fontWeight: 600, color: '#4afc38', height: '20px' }}>
                              <SkeletonText width="55%" height="100%" />
                            </span>
                          ) : (
                            <span style={{ fontSize: '20px', fontWeight: 600, color: '#4afc38' }}>
                              {roundToDecimalPlace(`${tokenBalance?.toExact()}`, '5')} hbHYPE
                            </span>
                          )}
                        </EntriesContainer>
                      </div>
                    </SubContainerBody>

                    <WithdrawalStatus refetchWithdrawals={loading} setRefetchWithdrawals={setLoading} />
                  </>
                </SubContainer>
              </div>
              <div>
                <SubContainer bg1={false}>
                  <SubContainerHeader>
                    <Tabs>
                      <StyledTabButton isActive={tab === 0} onClick={() => setTab(0)}>
                        Deposit
                      </StyledTabButton>
                      <StyledTabButton isActive={tab === 1} onClick={() => setTab(1)}>
                        Withdraw
                      </StyledTabButton>
                    </Tabs>

                    {tab === 0 ? (
                      <>
                        <p style={{ color: 'white', marginBottom: '0', fontSize: '14px' }}>
                          Please enter the amount of Tokens you wish to deposit.
                        </p>
                      </>
                    ) : (
                      <>
                        <p style={{ background: '#e3a5071A', borderRadius: '12px', padding: '12px', color: 'white' }}>
                          <u>Note</u>: Withdrawals can be requested one hour after depositing. Claims are processed once
                          daily, and assets are sent directly to your wallet address. Please note that withdrawals may
                          take up to two days to be fully completed.
                        </p>
                        <p style={{ color: 'white', marginBottom: '0', fontSize: '14px' }}>
                          Please enter the amount of hbHYPE Tokens you wish to withdraw.
                        </p>
                      </>
                    )}
                  </SubContainerHeader>
                  {tab === 0 ? (
                    <Stake
                      setRefresh={setRefresh}
                      /* key={randomKey} */
                      currencyIdA={currencyIdA}
                      setCurrencyIdA={setCurrencyIdA}
                    />
                  ) : (
                    <Unstake setRefresh={setRefresh} key={randomKey} />
                  )}
                </SubContainer>
              </div>
            </GridContainer>
          )}
        </AutoColumn>
      </AutoColumn>
    </>
  )
}
export default EarnHBHYPE
